// extracted by mini-css-extract-plugin
export var details = "_lh-0";
export var inspectorPopover = "_lh-1";